<template>
  <g
    id="Rear_Wheel-4"
    v-on:click="changeSeverity('leftRearWheel')"
    :class="severityClass"
  >
    <g>
      <g>
        <g>
          <rect
            class="cls-266"
            x="266.68"
            y="13.96"
            width=".3"
            height="21.23"
            transform="translate(29.34 148.67) rotate(-32.85)"
          />
          <rect
            class="cls-717"
            x="260.61"
            y="14.16"
            width=".5"
            height="2.36"
            transform="translate(33.4 143.96) rotate(-32.85)"
          />
        </g>
        <g>
          <rect
            class="cls-266"
            x="269.65"
            y="13.18"
            width=".3"
            height="21.23"
            transform="translate(13.42 111.13) rotate(-23.85)"
          />
          <rect
            class="cls-717"
            x="265.1"
            y="12.56"
            width=".5"
            height="2.36"
            transform="translate(17.1 108.46) rotate(-23.85)"
          />
        </g>
        <g>
          <rect
            class="cls-266"
            x="278.75"
            y="13.71"
            width=".3"
            height="21.23"
            transform="translate(1.76 -15.28) rotate(3.15)"
          />
          <rect
            class="cls-717"
            x="279.25"
            y="12.16"
            width=".5"
            height="2.36"
            transform="translate(1.16 -15.35) rotate(3.15)"
          />
        </g>
        <g>
          <rect
            class="cls-266"
            x="281.61"
            y="14.82"
            width=".3"
            height="21.23"
            transform="translate(11.67 -58.75) rotate(12.15)"
          />
          <rect
            class="cls-717"
            x="283.82"
            y="13.51"
            width=".5"
            height="2.36"
            transform="translate(9.45 -59.46) rotate(12.15)"
          />
        </g>
        <g>
          <rect
            class="cls-266"
            x="288.67"
            y="20.6"
            width=".3"
            height="21.23"
            transform="translate(84.56 -175.35) rotate(39.15)"
          />
          <rect
            class="cls-717"
            x="295.51"
            y="21.51"
            width=".5"
            height="2.36"
            transform="translate(80.73 -181.64) rotate(39.15)"
          />
        </g>
        <g>
          <rect
            class="cls-266"
            x="290.32"
            y="23.18"
            width=".3"
            height="21.23"
            transform="translate(121.87 -205.13) rotate(48.15)"
          />
          <rect
            class="cls-717"
            x="298.41"
            y="25.28"
            width=".5"
            height="2.36"
            transform="translate(119.12 -213.68) rotate(48.15)"
          />
        </g>
        <g>
          <rect
            class="cls-266"
            x="292.63"
            y="32.01"
            width=".3"
            height="21.23"
            transform="translate(258.94 -251.3) rotate(75.15)"
          />
          <rect
            class="cls-717"
            x="303.16"
            y="38.62"
            width=".5"
            height="2.36"
            transform="translate(264.13 -263.68) rotate(75.15)"
          />
        </g>
        <g>
          <rect
            class="cls-266"
            x="292.46"
            y="35.07"
            width=".3"
            height="21.23"
            transform="translate(308.22 -250.05) rotate(84.15)"
          />
          <rect
            class="cls-717"
            x="303.29"
            y="43.38"
            width=".5"
            height="2.36"
            transform="translate(316.93 -261.94) rotate(84.15)"
          />
        </g>
        <g>
          <rect
            class="cls-266"
            x="289.14"
            y="43.56"
            width=".3"
            height="21.23"
            transform="translate(444.18 -196.08) rotate(111.15)"
          />
          <rect
            class="cls-717"
            x="299.29"
            y="56.97"
            width=".5"
            height="2.36"
            transform="translate(461.85 -200.24) rotate(111.15)"
          />
        </g>
        <g>
          <rect
            class="cls-266"
            x="287.2"
            y="45.94"
            width=".3"
            height="21.23"
            transform="translate(480.55 -163.53) rotate(120.15)"
          />
          <rect
            class="cls-717"
            x="296.61"
            y="60.9"
            width=".5"
            height="2.36"
            transform="translate(499.64 -163.44) rotate(120.15)"
          />
        </g>
        <g>
          <rect
            class="cls-266"
            x="279.52"
            y="50.86"
            width=".3"
            height="21.23"
            transform="translate(547.97 -38.58) rotate(147.15)"
          />
          <rect
            class="cls-717"
            x="285.38"
            y="69.54"
            width=".5"
            height="2.36"
            transform="translate(563.95 -24.82) rotate(147.15)"
          />
        </g>
        <g>
          <rect
            class="cls-266"
            x="276.56"
            y="51.64"
            width=".3"
            height="21.23"
            transform="translate(554.95 7.3) rotate(156.15)"
          />
          <rect
            class="cls-717"
            x="280.9"
            y="71.13"
            width=".5"
            height="2.36"
            transform="translate(567.53 24.77) rotate(156.15)"
          />
        </g>
        <g>
          <rect
            class="cls-266"
            x="267.45"
            y="51.11"
            width=".3"
            height="21.23"
            transform="translate(531.4 138.06) rotate(-176.85)"
          />
          <rect
            class="cls-717"
            x="266.74"
            y="71.53"
            width=".5"
            height="2.36"
            transform="translate(529.59 159.97) rotate(-176.85)"
          />
        </g>
        <g>
          <rect
            class="cls-266"
            x="264.59"
            y="50"
            width=".3"
            height="21.23"
            transform="translate(510.79 175.61) rotate(-167.85)"
          />
          <rect
            class="cls-717"
            x="262.18"
            y="70.18"
            width=".5"
            height="2.36"
            transform="translate(503.96 196.35) rotate(-167.85)"
          />
        </g>
        <g>
          <rect
            class="cls-266"
            x="257.54"
            y="44.22"
            width=".3"
            height="21.23"
            transform="translate(422.91 260.03) rotate(-140.85)"
          />
          <rect
            class="cls-717"
            x="250.49"
            y="62.18"
            width=".5"
            height="2.36"
            transform="translate(405.19 270.8) rotate(-140.85)"
          />
        </g>
        <g>
          <rect
            class="cls-266"
            x="255.88"
            y="41.64"
            width=".3"
            height="21.23"
            transform="translate(387.92 277.83) rotate(-131.85)"
          />
          <rect
            class="cls-717"
            x="247.59"
            y="58.41"
            width=".5"
            height="2.36"
            transform="translate(368.8 283.96) rotate(-131.85)"
          />
        </g>
        <g>
          <rect
            class="cls-266"
            x="253.57"
            y="32.81"
            width=".3"
            height="21.23"
            transform="translate(276.77 299.8) rotate(-104.85)"
          />
          <rect
            class="cls-717"
            x="242.84"
            y="45.07"
            width=".5"
            height="2.36"
            transform="translate(260.68 293.07) rotate(-104.85)"
          />
        </g>
        <g>
          <rect
            class="cls-266"
            x="253.75"
            y="29.75"
            width=".3"
            height="21.23"
            transform="translate(239.59 297.05) rotate(-95.84)"
          />
          <rect
            class="cls-717"
            x="242.7"
            y="40.31"
            width=".5"
            height="2.36"
            transform="translate(226.45 287.41) rotate(-95.85)"
          />
        </g>
        <g>
          <rect
            class="cls-266"
            x="257.06"
            y="21.26"
            width=".3"
            height="21.23"
            transform="translate(134.68 260.26) rotate(-68.85)"
          />
          <rect
            class="cls-717"
            x="246.7"
            y="26.72"
            width=".5"
            height="2.36"
            transform="translate(131.82 248.15) rotate(-68.85)"
          />
        </g>
        <g>
          <rect
            class="cls-266"
            x="259.01"
            y="18.88"
            width=".3"
            height="21.23"
            transform="translate(103.48 238.77) rotate(-59.85)"
          />
          <rect
            class="cls-717"
            x="249.39"
            y="22.8"
            width=".5"
            height="2.36"
            transform="translate(103.53 227.8) rotate(-59.85)"
          />
        </g>
      </g>
      <g>
        <g>
          <rect
            class="cls-266"
            x="254.5"
            y="38.39"
            width=".3"
            height="21.23"
            transform="translate(285.09 -208.53) rotate(85.85)"
          />
          <rect
            class="cls-717"
            x="243.43"
            y="48.62"
            width=".5"
            height="2.36"
            transform="translate(275.71 -196.85) rotate(85.85)"
          />
        </g>
        <g>
          <rect
            class="cls-266"
            x="255.67"
            y="41.22"
            width=".3"
            height="21.23"
            transform="translate(248.09 -209.06) rotate(76.85)"
          />
          <rect
            class="cls-717"
            x="244.85"
            y="53.16"
            width=".5"
            height="2.36"
            transform="translate(242.26 -196.7) rotate(76.85)"
          />
        </g>
        <g>
          <rect
            class="cls-266"
            x="261.57"
            y="48.18"
            width=".3"
            height="21.23"
            transform="translate(137.92 -179.17) rotate(49.85)"
          />
          <rect
            class="cls-717"
            x="253.06"
            y="64.71"
            width=".5"
            height="2.36"
            transform="translate(140.33 -170.21) rotate(49.85)"
          />
        </g>
        <g>
          <rect
            class="cls-266"
            x="264.18"
            y="49.79"
            width=".3"
            height="21.23"
            transform="translate(103.9 -158.18) rotate(40.85)"
          />
          <rect
            class="cls-717"
            x="256.88"
            y="67.54"
            width=".5"
            height="2.36"
            transform="translate(107.58 -151.44) rotate(40.85)"
          />
        </g>
        <g>
          <rect
            class="cls-266"
            x="273.04"
            y="51.95"
            width=".3"
            height="21.23"
            transform="translate(22.91 -63.57) rotate(13.85)"
          />
          <rect
            class="cls-717"
            x="270.3"
            y="72.06"
            width=".5"
            height="2.36"
            transform="translate(25.4 -62.64) rotate(13.85)"
          />
        </g>
        <g>
          <rect
            class="cls-266"
            x="276.1"
            y="51.72"
            width=".3"
            height="21.23"
            transform="translate(6.25 -23.11) rotate(4.85)"
          />
          <rect
            class="cls-717"
            x="275.06"
            y="72.11"
            width=".5"
            height="2.36"
            transform="translate(7.18 -23.01) rotate(4.85)"
          />
        </g>
        <g>
          <rect
            class="cls-266"
            x="284.53"
            y="48.25"
            width=".3"
            height="21.23"
            transform="translate(-1.18 111.7) rotate(-22.15)"
          />
          <rect
            class="cls-717"
            x="288.58"
            y="67.87"
            width=".5"
            height="2.36"
            transform="translate(-4.72 114.01) rotate(-22.15)"
          />
        </g>
        <g>
          <rect
            class="cls-266"
            x="286.87"
            y="46.27"
            width=".3"
            height="21.23"
            transform="translate(11.96 156.67) rotate(-31.15)"
          />
          <rect
            class="cls-717"
            x="292.46"
            y="65.12"
            width=".5"
            height="2.36"
            transform="translate(7.91 160.97) rotate(-31.15)"
          />
        </g>
        <g>
          <rect
            class="cls-266"
            x="291.66"
            y="38.51"
            width=".3"
            height="21.23"
            transform="translate(96.1 271.08) rotate(-58.15)"
          />
          <rect
            class="cls-717"
            x="300.9"
            y="53.75"
            width=".5"
            height="2.36"
            transform="translate(95.59 281.76) rotate(-58.15)"
          />
        </g>
        <g>
          <rect
            class="cls-266"
            x="292.39"
            y="35.53"
            width=".3"
            height="21.23"
            transform="translate(136.42 297.81) rotate(-67.15)"
          />
          <rect
            class="cls-717"
            x="302.42"
            y="49.23"
            width=".5"
            height="2.36"
            transform="translate(138.68 309.75) rotate(-67.15)"
          />
        </g>
        <g>
          <rect
            class="cls-266"
            x="291.7"
            y="26.43"
            width=".3"
            height="21.23"
            transform="translate(276.03 330.81) rotate(-94.15)"
          />
          <rect
            class="cls-717"
            x="302.57"
            y="35.07"
            width=".5"
            height="2.36"
            transform="translate(288.58 340.9) rotate(-94.15)"
          />
        </g>
        <g>
          <rect
            class="cls-266"
            x="290.54"
            y="23.6"
            width=".3"
            height="21.23"
            transform="translate(323.5 325.06) rotate(-103.15)"
          />
          <rect
            class="cls-717"
            x="301.14"
            y="30.53"
            width=".5"
            height="2.36"
            transform="translate(339.1 332.41) rotate(-103.15)"
          />
        </g>
        <g>
          <rect
            class="cls-266"
            x="284.64"
            y="16.64"
            width=".3"
            height="21.23"
            transform="translate(447.58 262.5) rotate(-130.15)"
          />
          <rect
            class="cls-717"
            x="292.94"
            y="18.99"
            width=".5"
            height="2.36"
            transform="translate(466.83 257.27) rotate(-130.15)"
          />
        </g>
        <g>
          <rect
            class="cls-266"
            x="282.03"
            y="15.03"
            width=".3"
            height="21.23"
            transform="translate(478.84 229.62) rotate(-139.15)"
          />
          <rect
            class="cls-717"
            x="289.12"
            y="16.15"
            width=".5"
            height="2.36"
            transform="translate(496.92 219.7) rotate(-139.15)"
          />
        </g>
        <g>
          <rect
            class="cls-266"
            x="273.16"
            y="12.87"
            width=".3"
            height="21.23"
            transform="translate(533.05 111.74) rotate(-166.15)"
          />
          <rect
            class="cls-717"
            x="275.69"
            y="11.63"
            width=".5"
            height="2.36"
            transform="translate(540.8 91.3) rotate(-166.15)"
          />
        </g>
        <g>
          <rect
            class="cls-266"
            x="270.11"
            y="13.1"
            width=".3"
            height="21.23"
            transform="translate(537.54 70.18) rotate(-175.15)"
          />
          <rect
            class="cls-717"
            x="270.93"
            y="11.58"
            width=".5"
            height="2.36"
            transform="translate(540.32 48.4) rotate(-175.15)"
          />
        </g>
        <g>
          <rect
            class="cls-266"
            x="261.67"
            y="16.57"
            width=".3"
            height="21.23"
            transform="translate(514.56 -46.36) rotate(157.85)"
          />
          <rect
            class="cls-717"
            x="257.42"
            y="15.82"
            width=".5"
            height="2.36"
            transform="translate(502.73 -64.42) rotate(157.85)"
          />
        </g>
        <g>
          <rect
            class="cls-266"
            x="259.33"
            y="18.55"
            width=".3"
            height="21.23"
            transform="translate(496.63 -80.1) rotate(148.85)"
          />
          <rect
            class="cls-717"
            x="253.54"
            y="18.58"
            width=".5"
            height="2.36"
            transform="translate(481.21 -94.62) rotate(148.85)"
          />
        </g>
        <g>
          <rect
            class="cls-266"
            x="254.54"
            y="26.31"
            width=".3"
            height="21.23"
            transform="translate(420.45 -159.93) rotate(121.85)"
          />
          <rect
            class="cls-717"
            x="245.1"
            y="29.95"
            width=".5"
            height="2.36"
            transform="translate(401.25 -160.86) rotate(121.85)"
          />
        </g>
        <g>
          <rect
            class="cls-266"
            x="253.82"
            y="29.29"
            width=".3"
            height="21.23"
            transform="translate(389.35 -178.63) rotate(112.85)"
          />
          <rect
            class="cls-717"
            x="243.58"
            y="34.46"
            width=".5"
            height="2.36"
            transform="translate(371.35 -175.22) rotate(112.85)"
          />
        </g>
      </g>
    </g>
    <g>
      <g>
        <path
          class="cls-941"
          d="M316.27,43.03C316.27,19.27,297.01,0,273.25,0s-43.02,19.26-43.02,43.02c0,.73,.02,1.45,.06,2.17h0c0,.07,0,.14,.01,.21,.01,.26,.03,.52,.05,.78h0c.54,7.42,2.95,14.31,6.78,20.21,0,0,0,0,0,0,.04,.06,.07,.11,.11,.17h0c.14,.23,.28,.44,.43,.65,1.22,1.8,2.58,3.5,4.06,5.09t0,0s.05,.05,.07,.07c.02,.02,.04,.04,.07,.07,0,0,0,0,0,0h0c.17,.19,.35,.37,.53,.55h0c.93,.96,1.9,1.87,2.92,2.74,.38,.33,.76,.64,1.15,.95,.27,.22,.54,.43,.82,.64,0,0,0,0,0,0,.03,.02,.05,.04,.08,.06,.03,.02,.05,.04,.08,.06,0,0,0,0,0,0,.21,.16,.41,.31,.62,.45,0,0,0,0,0,0,.76,.55,1.54,1.07,2.33,1.57,.34,.22,.69,.43,1.04,.63,.46,.27,.93,.54,1.4,.79,1.65,.89,3.36,1.67,5.13,2.34,3.16,1.2,6.49,2.04,9.94,2.46h0c.07,0,.13,.01,.2,.02,.26,.03,.52,.06,.78,.09,1.43,.14,2.88,.22,4.35,.22,.73,0,1.45-.01,2.17-.05,.07,0,.14,0,.2-.01,.26-.01,.52-.03,.78-.05,4.38-.32,8.58-1.29,12.5-2.83,2.71-1.06,5.29-2.38,7.7-3.95h0c.06-.04,.11-.07,.17-.11,.22-.14,.44-.29,.65-.43,1.8-1.22,3.51-2.58,5.1-4.06,.04-.04,.09-.09,.14-.13t0,0c.19-.18,.38-.36,.57-.54,1.56-1.52,3-3.15,4.31-4.89,.04-.06,.08-.11,.12-.16,.16-.21,.31-.42,.47-.63,4.14-5.72,6.88-12.49,7.79-19.84,0,0,0,0,0,0,.01-.07,.02-.13,.03-.2,0-.06,.01-.12,.02-.18,.02-.18,.04-.36,.06-.54,0-.02,0-.03,0-.05h0c.14-1.44,.23-2.89,.23-4.36Zm-74.6,0c0-17.44,14.14-31.57,31.57-31.57s31.57,14.13,31.57,31.57c0,16.45-12.58,29.97-28.65,31.44h0c-.96,.09-1.93,.14-2.91,.14-2.21,0-4.37-.23-6.45-.66-1.08-.22-2.13-.5-3.17-.84,0,0-.01,0-.02,0h0c-.33-.1-.65-.21-.96-.33-1.71-.61-3.35-1.36-4.91-2.25-.31-.17-.61-.35-.91-.53-.29-.17-.57-.35-.85-.54-.3-.2-.61-.4-.9-.61-.45-.31-.88-.64-1.31-.98-.31-.24-.61-.49-.91-.74-6.84-5.79-11.18-14.44-11.18-24.1Z"
        />
        <path
          class="cls-717"
          d="M311.93,43.03c0-21.36-17.32-38.68-38.68-38.68s-38.68,17.32-38.68,38.68c0,12.07,5.52,22.84,14.19,29.94,.28,.23,.57,.46,.86,.68,.62,.48,1.26,.94,1.91,1.38,.31,.21,.62,.42,.94,.62,.65,.42,1.32,.82,2,1.19h0c.06,.04,.13,.07,.19,.11,1.64,.91,3.35,1.69,5.13,2.35,.07,.03,.14,.05,.2,.08,.51,.18,1.03,.36,1.55,.52,3.69,1.18,7.63,1.81,11.71,1.81,1.35,0,2.68-.07,3.99-.2,19.49-2,34.69-18.47,34.69-38.48Zm-71.12,0c0-17.91,14.53-32.44,32.44-32.44s32.44,14.53,32.44,32.44c0,16.97-13.03,30.9-29.63,32.32-.92,.08-1.86,.12-2.81,.12-2.19,0-4.34-.22-6.41-.63-1.22-.25-2.41-.56-3.57-.93-.01,0-.02,0-.03-.01-.33-.1-.64-.21-.96-.33-1.71-.61-3.35-1.36-4.91-2.24-.31-.17-.61-.34-.91-.52-.33-.2-.65-.4-.96-.61-.31-.2-.61-.4-.91-.61-.4-.28-.79-.58-1.18-.88-.3-.23-.58-.46-.87-.7-7.17-5.95-11.73-14.93-11.73-24.97Z"
        />
        <path
          class="cls-566"
          d="M311.5,43.03c0-21.13-17.13-38.25-38.25-38.25s-38.25,17.13-38.25,38.25c0,11.94,5.47,22.6,14.03,29.61,.28,.23,.57,.46,.86,.68,.58,.45,1.18,.89,1.79,1.3,.31,.21,.62,.42,.93,.62,.6,.38,1.22,.75,1.84,1.1,.13,.07,.26,.15,.38,.21,.03,.02,.06,.04,.08,.05h.01s.03,.01,.03,.02h0c1.54,.85,3.15,1.58,4.81,2.21h.01s.06,.03,.09,.04h.01s.04,.02,.07,.03c.14,.05,.28,.1,.42,.15,.49,.18,.98,.34,1.48,.5,3.6,1.12,7.42,1.72,11.39,1.72,1.23,0,2.44-.06,3.64-.17,19.42-1.83,34.61-18.18,34.61-38.08Zm-70.94,0c0-18.05,14.64-32.69,32.69-32.69s32.68,14.64,32.68,32.69c0,17.12-13.16,31.16-29.91,32.57-.92,.08-1.84,.12-2.78,.12-2.2,0-4.35-.22-6.43-.63-1.25-.25-2.47-.57-3.66-.96-.01,0-.01,0-.03-.01h0c-.32-.1-.64-.21-.96-.33-1.71-.61-3.35-1.36-4.91-2.25-.31-.17-.61-.34-.91-.52-.34-.2-.67-.41-1-.63-.31-.2-.61-.4-.91-.61-.39-.28-.78-.56-1.16-.86-.3-.23-.58-.45-.87-.69-7.25-6-11.87-15.06-11.87-25.2Z"
        />
      </g>
      <g>
        <path
          class="cls-204"
          d="M306.5,43.03c0-18.36-14.89-33.25-33.25-33.25s-33.25,14.89-33.25,33.25c0,4.01,.72,7.87,2.02,11.43,.07,.2,.15,.4,.23,.6,2.09,5.38,5.53,10.08,9.91,13.67,.28,.23,.57,.46,.86,.68,.36,.29,.74,.56,1.12,.83,.3,.21,.6,.42,.91,.62,.36,.23,.71,.46,1.08,.68,2.12,1.28,4.39,2.32,6.79,3.1h0c1.24,.41,2.52,.74,3.82,1,2.1,.42,4.28,.64,6.5,.64,.91,0,1.82-.04,2.71-.11,1.97-.16,3.89-.49,5.74-.98,.21-.06,.43-.11,.64-.18,.22-.06,.44-.12,.65-.19,13.61-4.17,23.5-16.83,23.5-31.79Zm-1.92,0c0,16.31-12.46,29.7-28.39,31.19-.97,.09-1.95,.14-2.94,.14-2.22,0-4.39-.23-6.48-.67-1.03-.21-2.05-.48-3.04-.8,0,0-.01,0-.02,0-.32-.1-.64-.21-.97-.33-1.71-.6-3.35-1.36-4.91-2.24-.31-.17-.61-.35-.91-.53-.28-.17-.55-.35-.82-.53-.31-.19-.61-.4-.91-.61-.46-.33-.91-.66-1.36-1.01-.32-.25-.62-.5-.92-.76-6.74-5.74-11.01-14.29-11.01-23.84,0-17.3,14.02-31.33,31.33-31.33s31.33,14.03,31.33,31.33Z"
        />
        <path
          class="cls-717"
          d="M306.84,43.03c0-2.1-.19-4.16-.56-6.15-.04-.25-.09-.49-.14-.74-.05-.24-.1-.47-.15-.7-3.44-14.9-16.79-26.01-32.74-26.01-4.91,0-9.57,1.05-13.78,2.95-.2,.09-.4,.18-.61,.28-11.36,5.38-19.21,16.96-19.21,30.37,0,10.48,4.8,19.85,12.32,26,.28,.23,.57,.46,.86,.68,.36,.28,.74,.55,1.11,.82,.3,.21,.6,.42,.91,.61,.37,.25,.74,.48,1.12,.71,.38,.23,.76,.45,1.16,.66h.01s.02,.01,.02,.01c1.37,.75,2.8,1.41,4.28,1.96l.04,.02h.01c.43,.17,.85,.31,1.28,.45,.02,0,.04,.02,.07,.02,1.24,.41,2.52,.74,3.82,1,2.13,.43,4.33,.64,6.58,.64,.9,0,1.79-.03,2.67-.1,17.31-1.36,30.93-15.84,30.93-33.49Zm-2.27,0c0,16.31-12.46,29.7-28.39,31.19-.97,.09-1.95,.14-2.94,.14-2.22,0-4.39-.23-6.48-.67-1.03-.21-2.05-.48-3.04-.8,0,0-.01,0-.02,0-.32-.1-.64-.21-.97-.33-1.71-.6-3.35-1.36-4.91-2.24-.31-.17-.61-.35-.91-.53-.28-.17-.55-.35-.82-.53-.31-.19-.61-.4-.91-.61-.46-.33-.91-.66-1.36-1.01-.32-.25-.62-.5-.92-.76-6.74-5.74-11.01-14.29-11.01-23.84,0-17.3,14.02-31.33,31.33-31.33s31.33,14.03,31.33,31.33Z"
        />
        <g class="cls-738">
          <path
            class="cls-253"
            d="M307.45,42.8c0-18.82-15.26-34.09-34.09-34.09-13.31,0-24.84,7.63-30.45,18.76,0,.01-.01,.03-.02,.04-2.31,4.6-3.61,9.79-3.61,15.29,0,10.66,4.9,20.18,12.57,26.44,.28,.23,.57,.45,.86,.68,.37,.28,.74,.55,1.12,.82,.3,.21,.6,.41,.9,.61,.38,.25,.77,.5,1.16,.73,.14,.08,.28,.17,.42,.24,.13,.08,.25,.15,.38,.22,1.63,.92,3.34,1.71,5.13,2.35,.14,.05,.28,.1,.41,.14,.15,.06,.3,.11,.46,.16,.05,.02,.1,.04,.15,.05,1.23,.4,2.48,.73,3.77,.99,2.19,.44,4.45,.67,6.76,.67,.85,0,1.69-.03,2.52-.09,12.16-.89,22.55-8.16,27.83-18.48,.09-.17,.17-.34,.25-.51,2.22-4.53,3.47-9.62,3.47-15.01Zm-47.98-30.42c4.23-1.94,8.94-3.02,13.89-3.02,15.94,0,29.27,11.15,32.62,26.08,.06,.23,.11,.47,.15,.7,.05,.24,.1,.49,.14,.74,.34,1.92,.52,3.9,.52,5.92,0,5.28-1.23,10.28-3.41,14.73-.09,.19-.18,.38-.28,.57-4.11,7.99-11.36,14.1-20.11,16.73-.21,.07-.43,.13-.65,.19-.21,.06-.43,.12-.65,.17-1.86,.48-3.77,.8-5.74,.95-.86,.07-1.73,.1-2.6,.1-2.26,0-4.47-.23-6.6-.65-1.3-.26-2.57-.59-3.81-1,0,0-.01,0-.01,0-2.39-.78-4.67-1.83-6.78-3.1-.36-.22-.72-.44-1.07-.67-.31-.2-.61-.4-.91-.61-.38-.27-.76-.54-1.12-.83-.29-.22-.58-.45-.86-.68-4.38-3.59-7.83-8.27-9.94-13.62-.08-.2-.16-.4-.23-.6-1.35-3.63-2.09-7.56-2.09-11.66,0-5.19,1.19-10.11,3.3-14.5,.09-.19,.18-.38,.28-.57,3.31-6.56,8.73-11.88,15.36-15.08,.2-.1,.4-.19,.61-.28Z"
          />
        </g>
        <path
          class="cls-485"
          d="M307.33,43.03c0-18.82-15.26-34.09-34.09-34.09-13.22,0-24.68,7.53-30.34,18.53,0,.01-.01,.03-.02,.04-2.38,4.65-3.73,9.93-3.73,15.52,0,10.65,4.89,20.16,12.54,26.41,.28,.23,.57,.45,.86,.68,.37,.28,.74,.56,1.12,.82,.3,.21,.6,.42,.91,.61,.39,.26,.79,.51,1.19,.75,.14,.08,.28,.17,.42,.25,.13,.07,.25,.14,.38,.22,1.63,.92,3.34,1.7,5.13,2.34,.14,.05,.28,.1,.41,.14,.15,.06,.3,.11,.46,.16,.09,.03,.18,.06,.27,.09,1.19,.38,2.42,.7,3.66,.95,2.18,.44,4.43,.67,6.74,.67,.88,0,1.75-.03,2.61-.1,12.21-.92,22.63-8.28,27.86-18.7,.09-.17,.17-.34,.25-.51,2.15-4.47,3.36-9.48,3.36-14.78Zm-.65,0c0,5.19-1.19,10.11-3.3,14.5-.09,.19-.18,.38-.28,.57-5.13,10.14-15.27,17.32-27.17,18.27-.89,.07-1.78,.11-2.69,.11-2.24,0-4.43-.22-6.54-.64-1.3-.25-2.58-.59-3.83-1-.01,0-.02,0-.03,0h0c-2.4-.78-4.67-1.83-6.8-3.11-.37-.23-.74-.45-1.1-.7-.31-.2-.61-.4-.91-.61-.38-.27-.75-.54-1.12-.82-.29-.22-.58-.45-.86-.68-7.48-6.13-12.25-15.44-12.25-25.87,0-5.28,1.23-10.28,3.41-14.73,.09-.19,.18-.38,.28-.57,5.55-10.78,16.79-18.15,29.74-18.15,18.47,0,33.44,14.97,33.44,33.44Z"
        />
      </g>
    </g>
    <g>
      <circle
        class="cls-617"
        cx="273.25"
        cy="43.02"
        r="15.66"
        transform="translate(3.9 106) rotate(-22.11)"
      />
      <circle
        class="cls-717"
        cx="273.25"
        cy="43.02"
        r="10.22"
        transform="translate(168.6 299.08) rotate(-76.72)"
      />
      <circle class="cls-566" cx="273.25" cy="43.02" r="5.27" />
      <path
        class="cls-781"
        d="M283.75,52.07c0,.61-.5,1.11-1.11,1.11s-1.11-.5-1.11-1.11,.5-1.11,1.11-1.11,1.11,.5,1.11,1.11Z"
      />
      <path
        class="cls-766"
        d="M279.16,55.56c-.25,.56-.9,.81-1.46,.56-.56-.25-.81-.9-.56-1.46,.25-.56,.9-.81,1.46-.56,.56,.25,.81,.9,.56,1.46Z"
      />
      <path
        class="cls-779"
        d="M273.55,56.88c-.45,.41-1.15,.37-1.56-.08-.41-.45-.37-1.15,.08-1.56,.45-.41,1.15-.37,1.56,.08s.37,1.15-.08,1.56Z"
      />
      <path
        class="cls-780"
        d="M267.89,55.8c-.58,.19-1.21-.13-1.39-.71-.19-.58,.13-1.21,.71-1.39,.58-.19,1.21,.13,1.39,.71,.19,.58-.13,1.21-.71,1.39Z"
      />
      <path
        class="cls-778"
        d="M263.16,52.52c-.61-.06-1.05-.61-.98-1.22,.06-.61,.61-1.05,1.22-.98,.61,.06,1.05,.61,.98,1.22-.06,.61-.61,1.05-1.22,.98Z"
      />
      <path
        class="cls-765"
        d="M260.17,47.6c-.53-.31-.71-.98-.4-1.51,.31-.53,.98-.71,1.51-.4,.53,.31,.71,.98,.4,1.51-.31,.53-.98,.71-1.51,.4Z"
      />
      <path
        class="cls-776"
        d="M259.44,41.88c-.36-.49-.25-1.19,.24-1.55s1.19-.25,1.55,.24c.36,.49,.25,1.19-.24,1.55s-1.19,.25-1.55-.24Z"
      />
      <path
        class="cls-777"
        d="M261.1,36.36c-.13-.6,.25-1.19,.85-1.31,.6-.13,1.19,.25,1.31,.85s-.25,1.19-.85,1.31-1.19-.25-1.31-.85Z"
      />
      <path
        class="cls-760"
        d="M264.86,32c.13-.6,.71-.98,1.31-.85s.98,.71,.85,1.31-.71,.98-1.31,.85c-.6-.13-.98-.71-.85-1.31Z"
      />
      <path
        class="cls-761"
        d="M270.07,29.54c.36-.49,1.05-.6,1.55-.24,.49,.36,.6,1.05,.24,1.55-.36,.49-1.05,.6-1.55,.24-.49-.36-.6-1.05-.24-1.55Z"
      />
      <path
        class="cls-755"
        d="M275.83,29.41c.53-.31,1.21-.12,1.51,.4,.31,.53,.12,1.21-.4,1.51-.53,.31-1.21,.12-1.51-.4-.31-.53-.12-1.21,.4-1.51Z"
      />
      <path
        class="cls-763"
        d="M281.14,31.64c.61-.06,1.15,.38,1.22,.98s-.38,1.15-.98,1.22c-.61,.06-1.15-.38-1.22-.98-.06-.61,.38-1.15,.98-1.22Z"
      />
      <path
        class="cls-757"
        d="M285.09,35.83c.58,.19,.9,.81,.71,1.39-.19,.58-.81,.9-1.39,.71-.58-.19-.9-.81-.71-1.39,.19-.58,.81-.9,1.39-.71Z"
      />
      <path
        class="cls-758"
        d="M286.99,41.27c.45,.41,.49,1.11,.08,1.56-.41,.45-1.11,.49-1.56,.08-.45-.41-.49-1.11-.08-1.56,.41-.45,1.11-.49,1.56-.08Z"
      />
      <path
        class="cls-762"
        d="M286.52,47.02c.25,.56,0,1.21-.56,1.46-.56,.25-1.21,0-1.46-.56-.25-.56,0-1.21,.56-1.46,.56-.25,1.21,0,1.46,.56Z"
      />
      <g>
        <path
          class="cls-314"
          d="M283.42,52.07c0,.43-.35,.77-.77,.77s-.77-.35-.77-.77,.35-.77,.77-.77,.77,.35,.77,.77Z"
        />
        <path
          class="cls-314"
          d="M278.86,55.42c-.17,.39-.63,.57-1.02,.39-.39-.17-.57-.63-.39-1.02s.63-.57,1.02-.39c.39,.17,.57,.63,.39,1.02Z"
        />
        <path
          class="cls-314"
          d="M273.33,56.63c-.32,.29-.81,.26-1.09-.06-.29-.32-.26-.81,.06-1.09,.32-.29,.81-.26,1.09,.06,.29,.32,.26,.81-.06,1.09Z"
        />
        <path
          class="cls-314"
          d="M267.79,55.49c-.41,.13-.84-.09-.98-.5s.09-.84,.5-.98c.41-.13,.84,.09,.98,.5,.13,.41-.09,.84-.5,.98Z"
        />
        <path
          class="cls-314"
          d="M263.19,52.19c-.43-.04-.73-.43-.69-.85,.04-.43,.43-.73,.85-.69,.43,.04,.73,.43,.69,.85-.04,.43-.43,.73-.85,.69Z"
        />
        <path
          class="cls-314"
          d="M260.34,47.31c-.37-.21-.5-.69-.28-1.06,.21-.37,.69-.5,1.06-.28s.5,.69,.28,1.06c-.21,.37-.69,.5-1.06,.28Z"
        />
        <path
          class="cls-314"
          d="M259.71,41.69c-.25-.35-.17-.83,.17-1.08s.83-.17,1.08,.17,.17,.83-.17,1.08-.83,.17-1.08-.17Z"
        />
        <path
          class="cls-314"
          d="M261.43,36.29c-.09-.42,.18-.83,.6-.92,.42-.09,.83,.18,.92,.6,.09,.42-.18,.83-.6,.92s-.83-.18-.92-.6Z"
        />
        <path
          class="cls-314"
          d="M265.19,32.07c.09-.42,.5-.69,.92-.6s.69,.5,.6,.92-.5,.69-.92,.6c-.42-.09-.69-.5-.6-.92Z"
        />
        <circle
          class="cls-314"
          cx="270.97"
          cy="30.19"
          r=".77"
          transform="translate(72.16 216.76) rotate(-49.54)"
        />
        <path
          class="cls-314"
          d="M276,29.7c.37-.21,.84-.09,1.06,.28s.09,.84-.28,1.06c-.37,.21-.84,.09-1.06-.28-.21-.37-.09-.84,.28-1.06Z"
        />
        <path
          class="cls-314"
          d="M281.18,31.97c.43-.04,.81,.26,.85,.69,.04,.43-.26,.81-.69,.85-.43,.04-.81-.26-.85-.69-.04-.43,.26-.81,.69-.85Z"
        />
        <path
          class="cls-314"
          d="M284.99,36.15c.41,.13,.63,.57,.5,.98-.13,.41-.57,.63-.98,.5-.41-.13-.63-.57-.5-.98,.13-.41,.57-.63,.98-.5Z"
        />
        <path
          class="cls-314"
          d="M286.77,41.52c.32,.29,.34,.78,.06,1.09s-.78,.34-1.09,.06c-.32-.29-.34-.78-.06-1.09s.78-.34,1.09-.06Z"
        />
        <path
          class="cls-314"
          d="M286.21,47.15c.17,.39,0,.85-.39,1.02-.39,.17-.85,0-1.02-.39-.17-.39,0-.85,.39-1.02,.39-.17,.85,0,1.02,.39Z"
        />
      </g>
    </g>
    <path
      class="cls-611"
      d="M296.94,42.19l-15.4-3.14-12.95-2.64c-.51-.1-.99,.28-.99,.81l-.03,11.27c0,.49,.42,.87,.9,.83l13.07-1.2,15.16-1.4c2.63-.24,2.83-4,.25-4.53Z"
    />
    <path
      class="cls-471"
      d="M296.94,42.19l-15.4-3.14v9.06l15.16-1.4c2.63-.24,2.83-4,.25-4.53Z"
    />
    <path
      class="cls-526"
      d="M233.11,67.28l.8,1.99,60.83-23.4c.42-.16,.69-.56,.69-1h0c0-.76-.76-1.28-1.47-1.01l-60.85,23.43Z"
    />
    <path
      class="cls-533"
      d="M238.79,67.39c-.42-.6-.82-1.2-1.21-1.82l-4.47,1.72,.8,1.99,4.89-1.88Z"
    />
    <path
      class="cls-267"
      d="M241.78,87.29v-12.71c-6-5.99-10.3-13.68-12.12-22.28h-11.43c-1.48,0-2.68,1.2-2.68,2.68v28.5c0,2.11,1.71,3.82,3.82,3.82h22.41Z"
    />
    <path
      class="cls-315"
      d="M219.02,42.57c-.33,0-.65,.13-.88,.37-.23,.24-.36,.55-.35,.88,.21,14.65,6.07,28.39,16.5,38.69,10.45,10.31,24.28,15.99,38.96,15.99s28.71-5.75,39.17-16.2l.56-.56-7.91-3.35-3.64-1.54-.25,.21c-7.85,6.45-17.77,10-27.94,10-22.74,0-41.57-17.04-43.81-39.63-.07-.76-.55-1.43-1.24-1.75l-5.35-2.44c-.96-.44-1.97-.66-3.02-.66h-.81Z"
    />
    <g>
      <rect
        class="cls-435"
        x="271.63"
        y="42.65"
        width="4.71"
        height="4.6"
        rx=".38"
        ry=".38"
        transform="translate(1.51 98.28) rotate(-20.39)"
      />
      <path
        class="cls-926"
        d="M290.92,83.34l-.1-.28-.02-.04-.39-1.03-.12-.3v-.03s-.39-1.02-.39-1.02h0s-.02-.04-.02-.04l-.13-.34-.26-.68-.11-.3-.02-.04-.38-1.02-.02-.05-.13-.34-.26-.68-.13-.34-.4-1.06-.13-.34-.26-.69-.13-.34-.39-1.06-.13-.34-.26-.68-.13-.34-.4-1.06-.13-.34-.26-.68-.12-.34-.4-1.07-.13-.34-.25-.68-.13-.34-.4-1.06-.13-.34-.26-.69-.13-.34-.4-1.06-.13-.34-.25-.68-.13-.34-.4-1.06-.13-.35-.26-.68-.13-.34-.4-1.06-.13-.34-.26-.68-.13-.34-.4-1.06-.12-.34-.26-.69-.13-.34-.45-1.2-.06-.18c-.03-.07-.11-.11-.18-.08l-4.33,1.61c-.07,.03-.11,.11-.09,.18l.07,.18,.06,.17,.13,.34,.26,.69,.13,.34,.4,1.06,.13,.34,.25,.68h0s.13,.35,.13,.35l.4,1.06,.13,.34,.26,.68,.13,.34,.4,1.06,.13,.34,.26,.69,.12,.34,.4,1.06,.13,.34,.26,.69,.13,.34,.4,1.06,.13,.34,.26,.68,.13,.34,.4,1.06,.13,.34,.25,.68,.13,.34,.4,1.06,.13,.34,.26,.68,.13,.34,.4,1.06,.12,.34,.26,.69,.13,.34,.4,1.06,.13,.34,.26,.68,.13,.34,.4,1.06,.13,.34,.26,.68,.13,.34,.39,1.06,.39,1.03,.13,.34,.4,1.06,.11,.29c.53-.17,1.05-.34,1.58-.52,1.01-.35,2.01-.75,3-1.18,0,0,.01,0,.02-.01Z"
      />
      <g>
        <path
          class="cls-105"
          d="M276.15,41.06c1.5,2.25,.09,5.23-2.65,5.46-1.22,.11-2.43-.49-3.11-1.51-1.5-2.25-.09-5.23,2.65-5.46,1.22-.1,2.43,.49,3.11,1.51Z"
        />
        <path
          class="cls-717"
          d="M275.96,41.23c1.33,2.04,.11,4.7-2.3,5.02-1.2,.16-2.41-.4-3.07-1.41-1.33-2.04-.11-4.7,2.3-5.02,1.2-.16,2.41,.4,3.07,1.41Z"
        />
        <path
          class="cls-707"
          d="M275.36,41.45c1.26,1.73,.14,4.1-2.03,4.2-.84,.04-1.65-.36-2.14-1.04-1.26-1.73-.13-4.1,2.03-4.2,.84-.04,1.65,.36,2.14,1.04Z"
        />
        <path
          class="cls-336"
          d="M275.25,41.57c1.13,1.58,.15,3.73-1.79,3.91-.83,.08-1.67-.31-2.16-.99-1.13-1.58-.15-3.73,1.79-3.91,.83-.08,1.67,.31,2.16,.99Z"
        />
        <path
          class="cls-22"
          d="M274.97,41.78c.97,1.36,.13,3.2-1.54,3.36-.71,.07-1.43-.26-1.85-.85-.97-1.36-.13-3.2,1.54-3.36,.71-.07,1.43,.26,1.85,.85Z"
        />
        <path
          class="cls-717"
          d="M272.24,42.42l-.14,.85c-.02,.13,.03,.27,.13,.35l.67,.55c.1,.09,.25,.11,.37,.06l.81-.3c.13-.05,.22-.16,.24-.29l.14-.85c.02-.13-.03-.27-.13-.35l-.67-.55c-.1-.09-.25-.11-.37-.06l-.81,.3c-.13,.05-.22,.16-.24,.29Z"
        />
        <path
          class="cls-254"
          d="M272.35,43.26l.88,.73s.09,.04,.14,.02l.95-.35-.03,.21-1.14,.42s-.1,0-.14-.02l-.88-.73s-.06-.08-.05-.13l.2-1.2,.2-.07-.17,1s.01,.1,.05,.13Z"
        />
      </g>
      <path
        class="cls-923"
        d="M274.99,46.34h2.19c.96,0,1.75,.78,1.75,1.75v6.39c0,.21-.17,.38-.38,.38h-4.93c-.21,0-.38-.17-.38-.38v-6.39c0-.96,.78-1.75,1.75-1.75Z"
        transform="translate(-.33 99.37) rotate(-20.39)"
      />
      <path
        class="cls-337"
        d="M272.17,48.21h0c-.12-.34,.05-.71,.38-.83l4.11-1.53c.34-.12,.71,.05,.83,.38h0c.03,.07,0,.15-.08,.18l-5.06,1.88c-.07,.03-.15,0-.18-.08Z"
      />
    </g>
    <g class="cls-738">
      <polygon
        class="cls-532"
        points="280.7 55.96 280.31 54.93 275.33 55.61 275.72 56.64 280.7 55.96"
      />
      <polygon
        class="cls-532"
        points="281.6 58.39 281.22 57.36 276.24 58.04 276.62 59.06 281.6 58.39"
      />
      <polygon
        class="cls-532"
        points="282.51 60.81 282.13 59.79 277.15 60.47 277.53 61.5 282.51 60.81"
      />
      <polygon
        class="cls-532"
        points="283.42 63.24 283.04 62.22 278.06 62.9 278.44 63.92 283.42 63.24"
      />
      <polygon
        class="cls-532"
        points="284.33 65.67 283.94 64.65 278.96 65.33 279.35 66.35 284.33 65.67"
      />
      <polygon
        class="cls-532"
        points="285.23 68.1 284.85 67.08 279.87 67.76 280.25 68.78 285.23 68.1"
      />
      <polygon
        class="cls-532"
        points="286.14 70.53 285.76 69.51 280.78 70.18 281.16 71.21 286.14 70.53"
      />
      <polygon
        class="cls-532"
        points="287.05 72.96 286.66 71.93 281.68 72.61 282.07 73.64 287.05 72.96"
      />
      <polygon
        class="cls-532"
        points="287.95 75.39 287.57 74.36 282.59 75.04 282.97 76.07 287.95 75.39"
      />
      <polygon
        class="cls-532"
        points="288.86 77.82 288.48 76.79 283.5 77.47 283.88 78.5 288.86 77.82"
      />
      <polygon
        class="cls-532"
        points="289.77 80.25 289.39 79.23 284.41 79.91 284.79 80.93 289.77 80.25"
      />
      <polygon
        class="cls-532"
        points="290.68 82.68 290.29 81.66 285.31 82.33 285.7 83.36 290.68 82.68"
      />
      <path
        class="cls-532"
        d="M287.91,84.53l-1.69,.23,.11,.29c.53-.17,1.05-.34,1.58-.52Z"
      />
    </g>
    <g>
      <path
        class="cls-532"
        d="M281.99,55.86c-.19-.46-.65-.72-1.14-.65l-.33,.05-5.38,.73s-.03,0-.04,0c-.03,0-.05,.01-.07,.02-.23,.08-.38,.32-.34,.57,.04,.29,.31,.49,.6,.46l.19-.03,5.41-.74,.1-.02-.08,.06,.39,1.06,.34-.26c.39-.3,.53-.81,.33-1.26Z"
      />
      <path
        class="cls-532"
        d="M282.89,58.29c-.19-.46-.65-.72-1.14-.65l-.33,.05-5.38,.73s-.03,0-.04,0c-.03,0-.05,.01-.07,.02-.23,.08-.38,.32-.34,.57,.04,.29,.31,.49,.6,.46l.19-.03,5.41-.74,.1-.02-.08,.06,.39,1.06,.34-.26c.39-.3,.53-.81,.33-1.26Z"
      />
      <path
        class="cls-532"
        d="M283.79,60.72c-.19-.46-.65-.72-1.14-.65l-.33,.05-5.38,.73s-.03,0-.04,0c-.03,0-.05,.01-.07,.02-.23,.08-.38,.32-.34,.57,.04,.29,.31,.49,.6,.46l.19-.03,5.41-.74,.1-.02-.08,.06,.39,1.06,.34-.26c.39-.3,.53-.81,.33-1.26Z"
      />
      <path
        class="cls-532"
        d="M284.69,63.15c-.19-.46-.65-.72-1.14-.65l-.33,.05-5.38,.73s-.03,0-.04,0c-.03,0-.05,.01-.07,.02-.23,.08-.38,.32-.34,.57,.04,.29,.31,.49,.6,.46l.19-.03,5.41-.74,.1-.02-.08,.06,.39,1.06,.34-.26c.39-.3,.53-.81,.33-1.26Z"
      />
      <path
        class="cls-532"
        d="M285.59,65.58c-.19-.46-.65-.72-1.14-.65l-.33,.05-5.38,.73s-.03,0-.04,0c-.03,0-.05,.01-.07,.02-.23,.08-.38,.32-.34,.57,.04,.29,.31,.49,.6,.46l.19-.03,5.41-.74,.1-.02-.08,.06,.39,1.06,.34-.26c.39-.3,.53-.81,.33-1.26Z"
      />
      <path
        class="cls-532"
        d="M286.49,68.01c-.19-.46-.65-.72-1.14-.65l-.33,.05-5.38,.73s-.03,0-.04,0c-.03,0-.05,.01-.07,.02-.23,.08-.38,.32-.34,.57,.04,.29,.31,.49,.6,.46l.19-.03,5.41-.74,.1-.02-.08,.06,.39,1.06,.34-.26c.39-.3,.53-.81,.33-1.26Z"
      />
      <path
        class="cls-532"
        d="M287.39,70.44c-.19-.46-.65-.72-1.14-.65l-.33,.05-5.38,.73s-.03,0-.04,0c-.03,0-.05,.01-.07,.02-.23,.08-.38,.32-.34,.57,.04,.29,.31,.49,.6,.46l.19-.03,5.41-.74,.1-.02-.08,.06,.39,1.06,.34-.26c.39-.3,.53-.81,.33-1.26Z"
      />
      <path
        class="cls-532"
        d="M288.28,72.87c-.19-.46-.65-.72-1.14-.65l-.33,.05-5.38,.73s-.03,0-.04,0c-.03,0-.05,.01-.07,.02-.23,.08-.38,.32-.34,.57,.04,.29,.31,.49,.6,.46l.19-.03,5.41-.74,.1-.02-.08,.06,.39,1.06,.34-.26c.39-.3,.53-.81,.33-1.26Z"
      />
      <path
        class="cls-532"
        d="M289.18,75.3c-.19-.46-.65-.72-1.14-.65l-.33,.05-5.38,.73s-.03,0-.04,0c-.03,0-.05,.01-.07,.02-.23,.08-.38,.32-.34,.57,.04,.29,.31,.49,.6,.46l.19-.03,5.41-.74,.1-.02-.08,.06,.39,1.06,.34-.26c.39-.3,.53-.81,.33-1.26Z"
      />
      <path
        class="cls-532"
        d="M290.08,77.74c-.19-.46-.65-.72-1.14-.65l-.33,.05-5.38,.73s-.03,0-.04,0c-.03,0-.05,.01-.07,.02-.23,.08-.38,.32-.34,.57,.04,.29,.31,.49,.6,.46l.19-.03,5.41-.74,.1-.02-.08,.06,.39,1.06,.34-.26c.39-.3,.53-.81,.33-1.26Z"
      />
      <path
        class="cls-532"
        d="M290.98,80.17c-.19-.46-.65-.72-1.14-.65l-.33,.05-5.38,.73s-.03,0-.04,0c-.03,0-.05,.01-.07,.02-.23,.08-.38,.32-.34,.57,.04,.29,.31,.49,.6,.46l.19-.03,5.41-.74,.1-.02-.08,.06,.39,1.06,.34-.26c.39-.3,.53-.81,.33-1.26Z"
      />
      <path
        class="cls-532"
        d="M291.95,82.88c-.01-.09-.04-.19-.07-.28-.19-.46-.65-.72-1.13-.65l-.32,.05h-.01l-4.97,.68-.41,.05s-.03,0-.04,.01c-.03,0-.05,.01-.07,.02-.23,.09-.38,.33-.34,.58,.04,.29,.3,.49,.6,.45l.19-.03,.45-.06,4.97-.68h.02l.08-.02-.06,.05h-.02s.1,.29,.1,.29c0,0,.01,0,.02-.01,.35-.14,.69-.3,1.03-.46Z"
      />
    </g>
    <path
      class="cls-611"
      d="M297.66,44.33c0,1.01-.82,1.83-1.83,1.83s-1.83-.82-1.83-1.83,.82-1.83,1.83-1.83,1.83,.82,1.83,1.83Z"
    />
    <circle class="cls-267" cx="295.82" cy="44.33" r="1.18" />
  </g>
</template>
<script>
export default {
  props: {
    severityClass: String
  },
  methods: {
    changeSeverity(section) {
      this.$emit('changeSeverity', section);
    }
  }
};
</script>
